import React, { useContext, useEffect } from "react";
import Home from "./Home";
import Login from "./Login";
import Terms from "./views/pages/Terms";
import Recuperar from "./views/Recuperar";
import Modal from "./components/global/Modal";
import { applyAppConfig } from "./utils/appconfig";
import { AuthContext } from "./context/AuthContext";
import ErrorAlert from "./components/global/ErrorAlert";
import AdjuntoView from "./components/folder/AdjuntoView";
import MobileModal from "./components/folder/MobileModal";
import SuccessAlert from "./components/global/SuccessAlert";
import { CapacitorContext } from "./context/CapacitorContext";
import { Routes, Route, useNavigate } from "react-router-dom";
import { AppConfigContext } from "./context/AppConfigContext";

const Main = () => {
  const navigate = useNavigate();
  const appconfig = useContext(AppConfigContext);
  const { user, logout, userLoggedIn } = useContext(AuthContext);
  const {
    platform,
    setupDevice,
    setupPlatform,
  } = useContext(CapacitorContext);

  useEffect(() => {
    setupDevice();
    setupPlatform();
    userLoggedIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    applyAppConfig(appconfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appconfig]);

  useEffect(() => {
    if (logout) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logout]);

  const renderContent = () => {
    if (user !== null) {
      return (
        <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/privacidad" element={<Terms />} />{" "}
        </Routes>
      );
    }
    return (
      <Routes>
        <Route path="/*" element={<Login />} />
        <Route path="/privacidad" element={<Terms />} />
        <Route path="/recuperar" element={<Recuperar />} />
      </Routes>
    );
  };

  return (
    <div className={platform !== "web" ? "ionic" : ""}>
      {renderContent()}
      {platform === "web" ? <Modal /> : <MobileModal />}
      <ErrorAlert />
      <SuccessAlert />
      <AdjuntoView />
    </div>
  );
};

export default Main;
